import {
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { Modal, Row, Col } from "react-bootstrap";
import {
  AiFillDelete,
  AiFillEdit,
  AiOutlineDelete,
  AiOutlineEdit,
} from "react-icons/ai";
import { InputAdornment } from "@mui/material";
import { server } from "../../common";
import { AxiosError } from "axios";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useSelectAccess } from "../../store/stateFunctions";
import useQuickLook from "../../quicklook/useQuickLook";

const initialValues = {
  title: "",
  description: "",
  category: "",
  written_by: "",
  posted_by: "",
  image: null,
  date: "",
};

const swalalert = withReactContent(Swal);

const AddInternalBlogs = ({ role }) => {
  const user = useSelectAccess("Internal User");
  const displayFile = useQuickLook();

  const [show, setShow] = useState(false);
  const [data, setData] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setIsEditMode(false);
    setSelectedData(null);
    formik.setValues(initialValues);
    setShow(true);
  };

  const handleShowEdit = (data) => {
    setSelectedData(data);
    setIsEditMode(true);
    setShow(true);
  };

  useEffect(() => {
    getData();
    // Check if in edit mode and selectedData is available
    if (isEditMode && selectedData) {
      formik.setValues({
        title: selectedData.title,
        description: selectedData.description,
        category: selectedData.category,
        written_by: selectedData.written_by,
        posted_by: selectedData.posted_by,
        image: selectedData.image,
        date: selectedData.date,
      });
    }
  }, [isEditMode, selectedData]);

  // Get
  const getData = () => {
    server
      .get("/int_blogs/getallind_blogs", {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  // Delete
  const deleteBlog = (data) => {
    swalalert
      .fire({
        title: "Delete Confirmation!",
        text: `Are You Sure That You Want To Delete ${data.title} ?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        confirmButtonClass: "btn btn-success",
        cancelButtonClass: "btn btn-danger",
        buttonsStyling: true,
      })
      .then(function (swalObject) {
        if (swalObject.isConfirmed) {
          server
            .delete(`/int_blogs/deleteind_blogs/${data.id}`, {
              headers: {
                "Content-Type": "application/json",
                Authorization: user.authToken,
              },
            })
            .then(function (response) {
              console.log("api response", response.data);
              if (response.status === 200 || response.status === 201) {
                swalalert.fire("Deleted!", "Blog has been deleted.", "success");
                getData();
              }
            })
            .catch((error) => {
              toast.error(error.response.data.message);
            });
        } else {
          swalalert.fire(
            "Cancelled",
            "Your imaginary file is safe :)",
            "error"
          );
        }
        //success method
      });
  };

  // update
  const handleUpdate = (values) => {
    const formData = new FormData();
    formData.append("title", values.title);
    formData.append("description", values.description);
    formData.append("category", values.category);
    formData.append("written_by", values.written_by);
    formData.append("posted_by", values.posted_by);
    formData.append("date", values.date);

    if (values.image) {
      formData.append("image", values.image);
    }

    server
      .put(`/int_blogs/updateind_blogs/${values.id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        formik.resetForm();
        getData();
        toast.success("Blog Updated successfully");
        handleClose();
      })
      .catch(function (error) {
        if (error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  // add
  const formik = useFormik({
    initialValues: isEditMode ? selectedData : initialValues,
    validationSchema: Yup.object({
      title: Yup.string().required("Enter a Blog title"),
      description: Yup.string().required("Enter a Blog Description"),
      category: Yup.string().required("Enter a Blog Category"),
      written_by: Yup.string().required("Enter a Blog Youtube written_by"),
      posted_by: Yup.string().required("Enter a Blog Youtube posted_by"),
      date: Yup.string().required("Enter a Blog Date"),
      image: Yup.mixed()
        .required("Please select an image")
        .test("fileSize", "File size is too large", (value) => {
          // Check the file size (if required)
          // Modify the limit according to your requirements
          return value ? value.size <= 5000000 : true;
        }),
    }),
    onSubmit: (values, action) => {
      if (isEditMode) {
        handleUpdate({ ...values, id: selectedData.id });
      } else {
        if (!values.image) {
          toast.error("Please select a images");
          return;
        }
        const formData = new FormData();
        formData.append("title", values.title);
        formData.append("description", values.description);
        formData.append("category", values.category);
        formData.append("written_by", values.written_by);
        formData.append("posted_by", values.posted_by);
        formData.append("image", values.image);
        formData.append("date", values.date);

        server
          .post("/blog/addblogs", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: user.authToken,
            },
          })
          .then(function (response) {
            if (response.status === 200 || response.status === 201) {
              toast.success("Blog Added successfully");
              formik.resetForm();
              handleClose();
              getData();
            }
          })
          .catch(function (error) {
            if (error.response?.data?.message)
              toast.error(error.response.data.message);
            else if (error.response?.data?.error) {
              toast.error(error.response.data.error);
            } else toast.error("Failed to connect to server");
          });
      }
    },
  });

  // search
  const SearchData = (searchValue) => {
    server
      .get(`/blog/searchblogs?search=${searchValue}`, {
        headers: {
          "Content-Type": "application/json",
          // "auth-token": user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  // search filter wise
  const FilterData = (event) => {
    const selectedValue = event.target.value;
    server
      .get(`/blog/Admfilter?filterByDate=${selectedValue}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  return (
    <>
      <div className="container">
        <div className="row my-3">
          <div className="col-md-4">
            <input
              type="search"
              className="form-control"
              placeholder="Search "
              onChange={(e) => SearchData(e.target.value)}
            />
          </div>
          <div className="col-md-4"></div>
          <div className="col-md-4">
            <select
              className="form-control"
              name=""
              id=""
              onChange={(e) => FilterData(e)} // Pass the event to FilterData
            >
              <option value="2days" defaultValue>
                Last 2 days
              </option>
              <option value="month" defaultValue>
                This Month
              </option>
              <option value="3months">Last 3 Months</option>
              <option value="6months">Last 6 Months</option>
            </select>
          </div>
        </div>
        <div className="d-flex position-relative mb-3 justify-content-center ">
          <h5 className="m-auto text-center">Previous Blogs</h5>
          <Button variant="contained" color="info" onClick={handleShow}>
            Add Blogs
          </Button>

          <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
              <Modal.Title>
                {isEditMode ? "Edit Blog Details" : "Add Blog Details"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col md={6}>
                    <div className="form-outline mb-2">
                      <TextField
                        name="title"
                        margin="dense"
                        type="text"
                        placeholder="Title"
                        variant="outlined"
                        label="Blog Title"
                        value={formik.values.title}
                        onChange={formik.handleChange}
                        fullWidth
                        required
                      ></TextField>
                      {formik.errors.title ? (
                        <p className="text-danger">{formik.errors.title}</p>
                      ) : null}
                    </div>

                    <div className="form-outline mb-2">
                      <TextField
                        name="description"
                        margin="dense"
                        type="  "
                        placeholder="Description"
                        variant="outlined"
                        label="Description"
                        value={formik.values.description}
                        onChange={formik.handleChange}
                        fullWidth
                        required
                      ></TextField>
                      {formik.errors.description ? (
                        <p className="text-danger">
                          {formik.errors.description}
                        </p>
                      ) : null}
                    </div>
                    <div className="form-outline mb-2">
                      <TextField
                        name="image"
                        margin="dense"
                        type="file"
                        variant="outlined"
                        label="Blog Images"
                        fullWidth
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <label htmlFor="image">Upload Image</label>
                            </InputAdornment>
                          ),
                          inputProps: {
                            accept: ".jpg, .png, .jpeg",
                            onChange: (event) => {
                              formik.setFieldValue(
                                "image",
                                event.currentTarget.files[0]
                              );
                            },
                          },
                        }}
                      />
                      {formik.errors.image ? (
                        <p className="text-danger">{formik.errors.image}</p>
                      ) : null}
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="form-outline mb-2">
                      <TextField
                        name="posted_by"
                        margin="dense"
                        type="text"
                        placeholder="Posted By"
                        variant="outlined"
                        label="Posted By"
                        value={formik.values.posted_by}
                        onChange={formik.handleChange}
                        fullWidth
                        required
                      ></TextField>
                      {formik.errors.posted_by ? (
                        <p className="text-danger">{formik.errors.posted_by}</p>
                      ) : null}
                    </div>

                    <div className="form-outline mb-2">
                      <TextField
                        name="written_by"
                        margin="dense"
                        type="text"
                        placeholder="Written By"
                        variant="outlined"
                        label="Written By"
                        value={formik.values.written_by}
                        onChange={formik.handleChange}
                        fullWidth
                        required
                      ></TextField>
                      {formik.errors.written_by ? (
                        <p className="text-danger">
                          {formik.errors.written_by}
                        </p>
                      ) : null}
                    </div>
                    <div className="mb-2">
                      <FormControl fullWidth required className="mt-2">
                        <InputLabel id="demo-simple-select-label">
                          Category
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          label="Year"
                          variant="outlined"
                          name="category"
                          value={formik.values.category}
                          onChange={formik.handleChange}
                          required
                        >
                          <MenuItem value="industry">Industry </MenuItem>
                          <MenuItem value="institute">Institute </MenuItem>
                          <MenuItem value="university">University </MenuItem>
                        </Select>
                        {formik.errors.category ? (
                          <p className="text-danger mb-0">
                            {formik.errors.category}
                          </p>
                        ) : null}
                      </FormControl>
                    </div>
                  </Col>
                </Row>

                <div className="form-group mb-2">
                  <TextField
                    name="date"
                    margin="dense"
                    type="date"
                    variant="outlined"
                    label="Posted Date"
                    value={formik.values.date}
                    onChange={formik.handleChange}
                    InputProps={{
                      inputProps: {
                        min: new Date().toISOString().substring(0, 10),
                      },
                    }}
                    fullWidth
                    required
                    style={{ margin: "8px 0" }}
                    InputLabelProps={{ shrink: true }}
                  ></TextField>
                  {formik.errors.date ? (
                    <p className="text-danger mb-0">{formik.errors.date}</p>
                  ) : null}
                </div>
                <div className="pt-1 mb-2 ">
                  <Button variant="contained" type="submit">
                    {isEditMode ? "Update" : "Post"}
                  </Button>
                </div>
              </form>
            </Modal.Body>
          </Modal>
        </div>

        <div className="container" style={{ overflow: "scroll" }}>
          <table className="table table-striped border">
            <thead className="bg-info">
              <tr>
                <th scope="col">Sr. No.</th>
                <th scope="col">Title</th>
                <th scope="col">Description</th>
                <th scope="col">Blog Images</th>
                <th scope="col">Posted By</th>
                <th scope="col">Written By</th>
                <th scope="col">Category</th>
                <th scope="col">Date</th>
                <th scope="col">Update</th>
                <th scope="col">Delete</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => {
                return (
                  <tr key={item.id}>
                    <th scope="row">{index + 1}</th>
                    <td>{item.title}</td>
                    <td>{item.description}</td>
                    <td>
                      <a href={item.image} target="_blank">
                        <img
                          width="50"
                          height="50"
                          src={item.image}
                          // alt={item.file}
                        />
                      </a>
                    </td>
                    <td>{item.posted_by}</td>
                    <td>{item.written_by}</td>
                    <td>{item.category}</td>
                    <td>{item.Date}</td>
                    <td>
                      <div className="btn banner text-white">
                        <AiFillEdit onClick={() => handleShowEdit(item)} />
                      </div>
                    </td>
                    <td>
                      <div className="btn banner text-white">
                        <AiFillDelete onClick={() => deleteBlog(item)} />
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default AddInternalBlogs;
